import React from "react";

class Title extends React.Component<React.HTMLAttributes<HTMLDivElement>> {
    public render() {
        const { children, className, ...rest } = this.props;
        return (
            <div className={`title_atom ${className || ""}`} {...rest}>
                {children}
            </div>
        );
    }
}
class Text extends React.Component<React.HTMLAttributes<HTMLDivElement>> {
    public render() {
        const { children, ...rest } = this.props;
        return (
            <div className="text_atom" {...rest}>
                {children}
            </div>
        );
    }
}

class SubText extends React.Component<React.HTMLAttributes<HTMLDivElement>> {
    public render(): React.ReactElement {
        const { children, ...rest } = this.props;
        return <div {...rest}>{children}</div>;
    }
}

export { Title, Text, SubText };
